import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { format } from '@breezeway/brzw-react-core';

import { reservations } from '../../utils/index';

import './schedule_reservation.scss';

const { GUEST_TYPES } = reservations;

const getReservationString = (stateName = '', reservation, timeKey = '') => {
  if (reservation) {
    let reservationString = stateName;

    const isOwnerReservation = _.get(reservation, 'type_guest.code') === GUEST_TYPES.OWNER;
    const reservationTime = reservation[timeKey];

    if (reservationTime) {
      reservationString += ` ${format.datetime.formatTime(reservationTime)}`;
    }

    if (isOwnerReservation) {
      reservationString += ' (owner)';
    }

    return reservationString;
  }

  return null;
};

const ScheduleReservation = props => {
  const { className, checkin, checkout, occupied } = props;

  if (!checkin && !checkout && !occupied) {
    return null;
  }

  const data = [];

  if (occupied) {
    if (occupied.guest_name) {
      data.push(`Occupied - ${occupied.guest_name}`);
    } else {
      data.push('Occupied');
    }
  } else {
    const checkoutStateString = getReservationString('Checkout', checkout, 'checkout_time');
    const checkinStateString = getReservationString('Check-in', checkin, 'checkin_time');

    if (checkoutStateString) {
      data.push(checkoutStateString);
    }

    if (checkinStateString) {
      data.push(checkinStateString);
    }
  }

  return (
    <div className={classnames('rep-schedule-reservations rep-schedule__reservation', className)}>
      {_.join(data, ' / ')}
    </div>
  );
};

ScheduleReservation.propTypes = {
  className: PropTypes.string,
  checkout: PropTypes.shape({
    checkout_time: PropTypes.string,
  }),
  checkin: PropTypes.shape({
    checkin_time: PropTypes.string,
  }),
  occupied: PropTypes.shape({
    guest_name: PropTypes.string,
  }),
};

export default ScheduleReservation;
